import { cn } from "@/lib/utils";
import { Text } from "./ui";

type QuestionHelperTextProps = {
  children: React.ReactNode;
  className?: string;
};

const QuestionHelperText = ({ children, className }: QuestionHelperTextProps) => {
  return (
    <Text className={cn('text-gray-600 text-md text-center', className)}>
      {children}
    </Text>
  );
};

export default QuestionHelperText;
